import { SxProps } from '@mui/system'

import { theme } from 'src/providers/ThemeProvider'

type HelpStylesType = {
  dialog: SxProps
  close: SxProps
  info: SxProps
  schedule: SxProps
  help: SxProps
  actionLink: SxProps
}

export const helpStyles: HelpStylesType = {
  dialog: {
    '& .MuiPaper-root': {
      maxWidth: '940px',
      padding: '12px 24px 24px 24px',
      width: '940px',
      borderRadius: '8px',
      boxShadow: '0px 2px 9px 0px rgba(113, 113, 113, 0.25)'
    },

    '& .MuiDialogContent-root': {
      padding: 0
    },

    '.mainTitle': {
      color: theme.colors.highlight200,
      textAlign: 'center',
      fontFamily: theme.corporate.primaryFont,
      fontSize: '24px',
      fontWeight: 700,
      lineHeight: '28px',
      padding: '10px'
    }
  },

  close: {
    padding: '0px',
    marginBottom: '8px',

    '& .MuiSvgIcon-root': {
      fontSize: '20px'
    }
  },

  info: {
    borderRadius: '8px',
    border: `1px solid ${theme.colors.main300}`,
    marginRight: '20px',
    padding: '12px',

    '& .MuiSvgIcon-root': {
      fontSize: '32px',
      fill: theme.corporate.primaryColor,
      marginBottom: '8px'
    },

    '& .MuiLink-root ': {
      color: theme.corporate.primaryColor,
      fontFamily: theme.corporate.primaryFont,
      fontSize: '18px',
      fontStyle: 'normal',
      fontWeight: 500,
      lineHeight: '20px',
      textDecoration: 'none',
      padding: '4px',
      borderRadius: '4px',

      '&:hover': {
        backgroundColor: theme.colors.blue08
      },

      '&:focus-visible': {
        backgroundColor: theme.colors.blue07,
        boxShadow: '0px 2px 9px 0px rgba(113, 113, 113, 0.25)'
      },

      '&:active': {
        backgroundColor: theme.colors.blue07
      }
    }
  },

  schedule: {
    color: theme.colors.gray600
  },

  help: {
    borderRadius: '8px',
    background: theme.colors.blue08,
    padding: '12px'
  },

  actionLink: {
    display: 'block',
    width: '100%',
    padding: '20px 8px',
    marginTop: '12px',
    borderRadius: '8px',
    backgroundColor: theme.colors.white01,
    textAlign: 'center',
    textDecoration: 'none',
    color: theme.corporate.primaryColor,
    fontFamily: theme.corporate.primaryFont,
    fontSize: '18px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '20px',

    '&:hover': {
      backgroundColor: theme.colors.blue08
    },

    '&:focus-visible': {
      backgroundColor: theme.colors.blue07,
      boxShadow: '0px 2px 9px 0px rgba(113, 113, 113, 0.25)'
    },

    '&:active': {
      backgroundColor: theme.colors.blue07
    }
  }
}
